export default {"src":"/_next/static/media/messages.a97ba287.svg","height":23,"width":25};